export default __webpack_public_path__ + "static/102-min-min-52a002b412d5a7be0492413ed13407ca.jpg";